<mat-card class="garment">
    <img [src]="garment.img" alt="photo of {{garment.name}}">
    <a mat-button color="primary" [routerLink]="['/garments/editor/', garment.id]" routerLinkActive="active"
        ariaCurrentWhenActive="page">
        {{garment.name}}
    </a>
    <p>{{garment.type}} - {{ calculateDaysSinceLastWorn(garment.date) }} days ago</p>
</mat-card>